import { useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { fileUrl } from "@/lib/api";
import { Field } from "@/components/FormField";

const MAX_IMAGES = 8;

async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data.path;
}

// onChange receives an updater: (prevImages) => nextImages
export function ImageUploader({ images, onChange }) {
  const [uploading, setUploading] = useState(false);

  const handleUpload = async (e) => {
    const files = Array.from(e.target.files || []).slice(0, MAX_IMAGES - images.length);
    if (!files.length) return;
    setUploading(true);
    try {
      const uploaded = [];
      for (const f of files) uploaded.push(await uploadFile(f));
      onChange((prev) => [...prev, ...uploaded]);
      toast.success(`${uploaded.length} image(s) uploaded`);
    } catch (err) {
      toast.error("Upload failed: " + (err.response?.data?.detail || err.message));
    } finally {
      setUploading(false);
    }
  };

  const remove = (idx) => onChange((prev) => prev.filter((_, i) => i !== idx));

  return (
    <Field label={`Images (${images.length}/${MAX_IMAGES})`}>
      <div className="grid grid-cols-4 gap-2 mb-2">
        {images.map((p, i) => (
          <div key={p} className="relative aspect-square border-2 border-black bg-[#F2F2F2]">
            <img src={fileUrl(p)} alt="" className="w-full h-full object-cover" />
            <button type="button" onClick={() => remove(i)} data-testid={`form-remove-img-${i}`} className="absolute top-1 right-1 bg-[#FF0000] text-white p-1 border border-black"><X size={12} /></button>
          </div>
        ))}
        {images.length < MAX_IMAGES && (
          <label className="aspect-square border-2 border-dashed border-black flex flex-col items-center justify-center cursor-pointer hover:bg-yellow-100 font-mono-data text-xs uppercase" data-testid="form-upload-label">
            {uploading ? <Loader2 className="animate-spin" size={20} /> : <><Upload size={20} /><span className="mt-1">Add Photo</span></>}
            <input data-testid="form-upload-input" type="file" multiple accept="image/*" onChange={handleUpload} className="hidden" disabled={uploading} />
          </label>
        )}
      </div>
    </Field>
  );
}
